'use client';

import { useExtensionFlow } from '@/widgets/ExtensionFlow/context/ExtensionFlowContext';

import { AccessLevelProps } from '@/common/components/SalesFlow/StepsContent/components/AccessLevel/AccessLevel.interfaces';
import { ACCESS_LEVEL_EXCLUDED_QUERY_KEYS, useAccessLevelSelection } from '@/common/components/SalesFlow/StepsContent/components/AccessLevel/AccessLevel.service';

import AccessLevel from '@/common/components/SalesFlow/StepsContent/components/AccessLevel/AccessLevel';
import { UrlParamKeys } from '@/common/utils/constants';

export default function ExtensionAccessLevel({
    data, lang, step, translations, fetchingCombinationComplete, setIsPaymentWidgetVisible, isExtending }: Omit<AccessLevelProps, 'handleItemSelect' | 'isItemSelected'> & {
        translations: Record<string, string>,
        fetchingCombinationComplete: boolean,
        isExtending: boolean
    }) {

    const { setVoucherSource } = useExtensionFlow();

    const excludedQueryKeys = [
        ...ACCESS_LEVEL_EXCLUDED_QUERY_KEYS,
        UrlParamKeys.SkipPayment
    ];

    const { handleItemSelect, isItemSelected, overlayComponent } = useAccessLevelSelection({
        data,
        lang,
        step,
        translations,
        fetchingCombinationComplete,
        excludedQueryKeys,
        setVoucherSource,
        setIsPaymentWidgetVisible,
        isExtending
    })

    return (
        <>
            <AccessLevel
                data={data}
                lang={lang}
                step={step}
                handleItemSelect={handleItemSelect}
                isItemSelected={isItemSelected}
            />
            {overlayComponent}
        </>
    )
}